import Image from "next/image";
import { ReactNode } from "react";

import { cn } from "@/lib/utils";
import { NoxusTooltip } from "@/components/UI/NoxusTooltip";

const BUBBLE_SIZE = {
  sm: "h-2.5 w-2.5 -right-0.5 -top-0.5",
  md: "h-3 w-3 -right-1 -top-1",
} as const;

const MARK_SIZE = {
  sm: "h-1.5 w-1.5",
  md: "h-2 w-2",
} as const;

export function NoxusOnlyIcon({
  children,
  size = "md",
  className,
  tooltip = "Noxus-internal only: your users don't see this",
}: {
  children: ReactNode;
  size?: keyof typeof BUBBLE_SIZE;
  className?: string;
  tooltip?: string | null;
}) {
  const icon = (
    <span className={cn("relative inline-flex shrink-0", className)}>
      {children}
      <span
        className={cn(
          "absolute flex items-center justify-center rounded-full bg-background ring-1 ring-border",
          BUBBLE_SIZE[size]
        )}
      >
        <Image
          src="/logos/noxus-o.svg"
          alt=""
          width={8}
          height={8}
          className={MARK_SIZE[size]}
        />
      </span>
    </span>
  );

  if (!tooltip) return icon;
  return (
    <NoxusTooltip content={tooltip} asChild>
      {icon}
    </NoxusTooltip>
  );
}
